module.exports = __webpack_public_path__ + "img/weixinqr.9c1fbcfa.jpg";